/* FAQ: <details> rows between hairlines, readable line length. */
.list {
  max-width: 860px;
  border-top: 1px solid var(--border);
}

.item {
  border-bottom: 1px solid var(--border);
}

.question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 44px;
  padding: 14px 0;
  cursor: pointer;
  list-style: none;
}

.question::-webkit-details-marker {
  display: none;
}

.heading {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
}

.icon {
  flex: none;
  transition: transform 0.2s ease;
}

.item[open] .icon {
  transform: rotate(180deg);
}

.answer {
  margin: 0;
  padding: 0 0 18px;
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-secondary);
}

@media (min-width: 1024px) {
  .heading {
    font-size: 16px;
  }
}
